import React from 'react'
import { connect } from 'react-redux'
import { openSubscribeModal } from 'subscribe-modal'
import css from '../style.scss'

export const FooterSubscribe = ({ openSubscribeModal }) => {
  return (
    <button type='button' className={css.subscribe} onClick={openSubscribeModal}>
      Subscribe to receive NCFDD email updates
    </button>
  )
}

export default connect(null, { openSubscribeModal })(FooterSubscribe)
